/*
 * Module for showing the response history modal
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "i18n/i18n",
  "modules/topicsSplit/topic/topicResponseHistoryModal/topicResponseHistoryModalView",
  "modules/topicsSplit/topic/topicResponseHistoryModal/topicResponseHistoryModalModel",
  "modules/shared/sortableList/sortableListModule",
  "modules/topicsSplit/topic/topicResponseHistoryModal/topicResponseHistoryViewer/topicResponseHistoryViewerModule",
  "modules/topicsSplit/topic/topicResponseEditorModal/topicResponseEditorModalModule",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  i18next,
  TopicResponseHistoryModalView,
  TopicResponseHistoryModalModel,
  SortableListModule,
  TopicResponseHistoryViewerModule,
  TopicResponseEditorModalModule,
  KbMenuModel,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicResponseHistoryModal";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (historyBundle) {
      //object containing all the needed data for this modal
      //we need the following 3 things for updating a response via a rollback
      this.conversationNode = historyBundle.conversationNode;
      this.selectedTouchPoint = historyBundle.selectedTouchPoint;
      this.selectedLanguage = historyBundle.selectedLanguage;
      this.historyCollection = historyBundle.historyCollection;
      // set status names
      this.layout = new TopicResponseHistoryModalView.topicResponseHistoryModalLayout();
      const headers = Messenger.reqres.request("topic:response:history:headers");
      this.historyList = this.addSubModule(
        new SortableListModule({
          region: this.layout.historyList,
          headers: headers,
          hideControls: true,
          namespace: this.name,
        }),
      );
      this.historyPreview = this.addSubModule(
        new TopicResponseHistoryViewerModule({ region: this.layout.historyPreview }),
      );
      this.layout.on("show", this._showHistory, this);
      this.showRegion(this.layout);
    },
    _showHistory: function () {
      const historyCollection = this.historyCollection;
      historyCollection.onSynced(() => {
        historyCollection.each((history) => {
          if (history.get("oldStatus") && history.get("newStatus")) {
            history.set(
              "oldStatusName",
              KbMenuModel.statuses.getStatusName(history.get("oldStatus").statusId),
            );
            history.set(
              "newStatusName",
              KbMenuModel.statuses.getStatusName(history.get("newStatus").statusId),
            );
          } else {
            history.set("oldStatusName", "");
            history.set("newStatusName", "");
          }
        });
        this.historyList.show(historyCollection);
      }, this);
    },
    _saveResponseAndDeleteCollabDataPromise: async function (responseTemplate) {
      if (responseTemplate) {
        await responseTemplate.saveModelPromise();
        await responseTemplate.deleteCollabData();
      } else {
        throw error("Could not find response to update");
      }
    },
    _setUpVents: function () {
      Messenger.vent.on(
        this.name + ":selected:row",
        (rowModel) => {
          //process the history model's response for privileged areas (check a boolean to see if we've done this already)
          if (!rowModel.processedPrivilegedArea) {
            const processedResponse = this.conversationNode.addPrivilegedRoleNamesToResponse(
              rowModel.get("response"),
            );
            rowModel.set("response", processedResponse);
            rowModel.processedPrivilegedArea = true;
          }
          this.historyPreview.show(rowModel);
        },
        this,
      );

      Messenger.vent.on(
        "rollback:topic:response",
        (response) => {
          Messenger.vent.trigger("show:saving:display");
          //remove any privileged area role names from the response (these names are temporarily added in to be visible in the UI)
          response = this.conversationNode.removePrivilegedRoleNamesFromResponse(response);
          //update the conversation's response
          const responseTemplate = this.conversationNode.setResponse(
            this.selectedTouchPoint,
            this.selectedLanguage,
            response,
          );
          // fire event that the node was selected in order to rerender the response preview
          Messenger.vent.trigger("selected:node", this.conversationNode);
          this._saveResponseAndDeleteCollabDataPromise(responseTemplate)
            .catch((e) => {
              console.error("Failed to update response and delete collaboration data", e);
              Messenger.okDialog(i18next.t("topic.responseHistory.rollback.error"));
            })
            .finally(() => {
              Messenger.vent.trigger("close:saving:display");
              Messenger.vent.trigger("close:modal");
            });
        },
        this,
      );
    },
  });
});
